import { APP_ROUTES } from 'shared/constants/routes'

export const ANALYTICS_TRACKING_SOURCE = 'container_navigation_v1'

export const MIN_TRACKED_TIME_SECONDS = 1

export const AUTH_ANALYTICS_PATHS = [
  APP_ROUTES.authCheck.path,
  APP_ROUTES.login.path,
  APP_ROUTES.loginWithToken.path,
  APP_ROUTES.register.path,
  APP_ROUTES.userSelect.path,
  APP_ROUTES.forgotPassword.path,
  APP_ROUTES.setPassword.path,
  APP_ROUTES.activate.path
]

export const ANALYTICS_CHECKPOINT_INTERVAL_MS = 30 * 1000
// Timer gaps are an estimate of suspension, not an input/idle policy. A busy
// main thread can also exceed this threshold
export const ANALYTICS_MAX_FOREGROUND_GAP_MS = 60 * 1000
export const ANALYTICS_CLOCK_DRIFT_TOLERANCE_MS = 2 * 1000
export const ANALYTICS_CHECKPOINT_RETENTION_MS = 7 * 24 * 60 * 60 * 1000

/**
 * How far back a reported `usage_day` may point, in whole UTC days.
 *
 * This must stay within the window Usage Analytics still re-syncs: a
 * `usage_day` older than that window is never read, so the event is dropped
 * instead of counted. Raising it therefore requires raising two knobs in
 * usage-analytics-service first, or events start disappearing silently — the
 * coverage logs there cannot see a day nothing asked for:
 *
 * - USAGE_DAY_LOOKAHEAD_DAYS >= this + 1. The event lands in the BigQuery
 *   shard of the day it was *sent*, which is up to this many days after the
 *   day it is tagged with, and reading a usage day only scans that many shards
 *   forward. This is the binding constraint.
 * - REPORT_SYNC_LOOKBACK_DAYS >= this + 2. At + 1 exactly one run can still
 *   reach the day, and a day already marked synced is never revisited outside
 *   the lookback window, so one skipped cron run loses the event.
 *
 * Retention only bounds local cleanup. Chunks outside this reporting window
 * expire; never move their time onto a newer day to make them countable.
 */
export const ANALYTICS_MAX_USAGE_DAY_AGE_DAYS = 1
export const ANALYTICS_MEASUREMENT_ID_SESSION_KEY =
  'analytics_tracking_measurement_id'
export const ANALYTICS_MEASUREMENT_CHECKPOINT_SESSION_KEY =
  'analytics_tracking_measurement_checkpoint'
